import React, { createContext, useReducer, useContext } from 'react';

const defaultEntity = {
  provider: "",
  clientDesignClients: [],
  name: "",
  design: "",
  designType: 0,
  language: "",
  inputType: "text",
  ocrOption: "",
  fileId: 0,
  productionStyleGuideId: null,
  productionStyleGuideType: "Unknown",
  productionStyleGuideMetadata: {},
  priority: 1
};

const initialStyleGuideState = {
  entity: { ...defaultEntity },
  fileText: "",
  isProcessing: false,
  isUploading: false,
  errors: [],
};

export const ACTION_TYPES = {
  SET_ENTITY: 'SET_ENTITY',
  UPDATE_ENTITY_FIELD: 'UPDATE_ENTITY_FIELD',
  SET_DESIGN_TEXT: 'SET_DESIGN_TEXT',
  SET_FILE_TEXT: 'SET_FILE_TEXT',
  SET_PROCESSING: 'SET_PROCESSING',
  SET_UPLOADING: 'SET_UPLOADING',
  SET_ERRORS: 'SET_ERRORS',
  RESET_STATE: 'RESET_STATE',
  INITIALIZE_EDIT: 'INITIALIZE_EDIT',
};

function styleGuideReducer(state, action) {
  switch (action.type) {
    case ACTION_TYPES.SET_ENTITY:
      return {
        ...state,
        entity: action.payload
      };
      
    case ACTION_TYPES.UPDATE_ENTITY_FIELD:
      return {
        ...state,
        entity: {
          ...state.entity,
          [action.payload.field]: action.payload.value
        }
      };
      
    case ACTION_TYPES.SET_DESIGN_TEXT:
      return {
        ...state,
        entity: {
          ...state.entity,
          design: action.payload
        }
      };
      
    case ACTION_TYPES.SET_FILE_TEXT:
      return {
        ...state,
        fileText: action.payload
      };
      
    case ACTION_TYPES.SET_PROCESSING:
      return {
        ...state,
        isProcessing: action.payload
      };
      
    case ACTION_TYPES.SET_UPLOADING:
      return {
        ...state,
        isUploading: action.payload
      };
      
    case ACTION_TYPES.SET_ERRORS:
      return {
        ...state,
        errors: action.payload
      };
      
    case ACTION_TYPES.RESET_STATE:
      return {
        ...initialStyleGuideState,
        entity: { ...defaultEntity }
      };
      
    case ACTION_TYPES.INITIALIZE_EDIT:
      const normalizedEntity = {
        ...action.payload,
        design: action.payload.design || "",
        inputType: action.payload.inputType || "text",
        ocrOption: action.payload.ocrOption || "",
        fileId: action.payload.fileId || 0,
        language: action.payload.language || "",
        designType:
          typeof action.payload.designType === "number"
            ? action.payload.designType
            : 0,
        productionStyleGuideId: action.payload.productionStyleGuideId ?? null,
        productionStyleGuideType:
          action.payload.productionStyleGuideType || "Unknown",
        productionStyleGuideMetadata:
          action.payload.productionStyleGuideMetadata || {},
        priority:
          typeof action.payload.priority === "number"
            ? action.payload.priority
            : 1
      };
      
      return {
        ...state,
        entity: normalizedEntity,
        fileText: normalizedEntity.design || ""
      };
      
    default:
      return state;
  }
}

export const StyleGuideContext = createContext();

export function StyleGuideProvider({ children }) {
  const [state, dispatch] = useReducer(styleGuideReducer, initialStyleGuideState);
  
  return (
    <StyleGuideContext.Provider value={{ state, dispatch }}>
      {children}
    </StyleGuideContext.Provider>
  );
}

export function useStyleGuide() {
  const context = useContext(StyleGuideContext);
  
  if (!context) {
    throw new Error('useStyleGuide must be used within a StyleGuideProvider');
  }
  
  return context;
}
